const Separator = ({ vertical = false, section = "" }) => (
	<div
		className={`help-separator--${vertical ? "vertical" : "horizontal"}${
			section ? ` help-separator--${section}` : ""
		}`}
	></div>
);

export default Separator;
